// StockPage.js
import React, { useState, useEffect } from 'react';
import api from '../utils/api';

export function StockPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/farm/stock').then(r => setItems(r.data.data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h2 className="section-title">Stok Durumu</h2>
      <div className="card">
        {loading ? <div className="empty-state"><p>Yükleniyor...</p></div>
          : items.length === 0 ? (
            <div className="empty-state"><div className="icon">📦</div><p>Stok kaydı bulunamadı</p></div>
          ) : items.map(item => (
            <div key={item.id} className="txn-item">
              <div className="txn-main">
                <div className="txn-name">{item.product_name}</div>
                {item.warehouse_location && <div className="txn-meta">{item.warehouse_location}</div>}
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontWeight: 800, fontSize: '1rem', color: '#2d5a27' }}>
                  {new Intl.NumberFormat('tr-TR').format(item.quantity)} {item.unit}
                </div>
                {item.avg_cost_per_unit && (
                  <div style={{ fontSize: '0.75rem', color: '#aaa' }}>
                    Ort. ₺{parseFloat(item.avg_cost_per_unit).toFixed(2)}/{item.unit}
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default StockPage;
